"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var core_1 = require("@angular/core");
var utilities_1 = require("./utilities");
var SisSimpleSettings = /** @class */ (function () {
    function SisSimpleSettings(communicationService) {
        this.communicationService = communicationService;
    }
    SisSimpleSettings.prototype.valueChange = function (hint) {
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            bindings: {},
            state: { hint: utilities_1.multilingualToString(hint) },
        }));
    };
    Object.defineProperty(SisSimpleSettings.prototype, "state", {
        set: function (value) {
            if (value['hint'] !== '') {
                this.hint = utilities_1.stringToMultilingual(value['hint']);
            }
        },
        enumerable: true,
        configurable: true
    });
    SisSimpleSettings.propDecorators = {
        "state": [{ type: core_1.Input },],
    };
    return SisSimpleSettings;
}());
exports.SisSimpleSettings = SisSimpleSettings;
//# sourceMappingURL=sis-simple-settings.js.map